<template>
  <g class="vg-chart vg-bar-chart" :transform="transform">
    <bar-plot
      :data-view="data"
      :x-scale="xScale"
      :y-scale="yScale"
      :animation-stagger="0.033">
    </bar-plot>
    <y-gridlines
      :interval="yInterval"
      :x-scale="xScale"
      :y-scale="yScale">
    </y-gridlines>
    <x-axis
      :interval="xInterval"
      :x-scale="xScale"
      :y-scale="yScale"
      :post-transform="transform"
      :tick-size="6"
      :tick-padding="6"
      :formatted="xFormat"
      anchor="top">
    </x-axis>
    <y-axis
      :interval="yInterval"
      :x-translate="xRange[1]"
      :y-scale="yScale"
      :post-transform="transform"
      :tick-size="0"
      :tick-padding="2"
      :formatted="yFormat"
      anchor="left">
    </y-axis>
    <slot v-bind="{xScale, yScale}"></slot>
  </g>
</template>

<script>
import BarPlot from "vue-graphics/components/BarPlot.vue";
import YGridlines from "vue-graphics/components/YGridlines.js";
import XAxis from "vue-graphics/components/XAxis.vue";
import YAxis from "vue-graphics/components/YAxis.vue";
import { userSpaceMixin } from "vue-graphics/mixins";
import { TransformHelper, IntervalHelper } from "vue-graphics/helpers";
import { scaleBand, scaleLinear } from "d3-scale";

export default {
  name: "BarChart",
  components: {
    BarPlot,
    YGridlines,
    XAxis,
    YAxis,
  },
  mixins: [userSpaceMixin],
  props: {
    data: Array,
    xDomain: Array,
    yDomain: Array,
    xFormat: Function,
    yFormat: Function,
    interval: Number,
  },
  computed: {
    layout() {
      return new TransformHelper().flipY();
    },
    xScale() {
      return scaleBand()
        .domain(this.xDomain)
        .range(this.xRange)
        .paddingInner(0)
        .paddingOuter(0);
    },
    yScale() {
      return scaleLinear()
        .domain(this.yDomain)
        .rangeRound(this.yRange);
    },
    xInterval() {
      return scale =>
        IntervalHelper.MIDDLE()(scale).filter((v, i) => i > 0 && i % 70 === 0);
    },
    yInterval() {
      return IntervalHelper.MULTIPLES_OF(this.interval);
    },
  },
  methods: {
    x(d, i) {
      return i;
    },
    y(d) {
      return d.new_cases;
    },
  },
};
</script>

<style lang="scss">
.vg-bar-chart {
  .vg-bar-plot rect {
    stroke: rgb(212, 136, 61);
    fill: rgb(212, 136, 61);
    stroke-width: 0.5;
  }

  .vg-tick line {
    stroke: $black;
  }

  .vg-text-label {
    font-family: $font_CuratorRegular;
    font-size: 13px;
  }

  .vg-gridlines {
    stroke: $screen;
    stroke-width: 0;
  }

  .vg-y-axis .vg-tick:last-child .vg-text-label {
    font-family: $font_CuratorBold;
  }
}
</style>
